import { Link as RouterLink } from 'react-router-dom';
import {
  Breadcrumbs as MuiBreadcrumbs,
  BreadcrumbsProps as MuiBreadcrumbsProps,
  Link,
  Typography,
} from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import { useIsMobile } from '@app/app/hooks/useIsMobile';

import { BreadcrumbsOption } from '../types';

export interface BreadcrumbsProps extends MuiBreadcrumbsProps {
  readonly options: BreadcrumbsOption[];
}

export const Breadcrumbs = ({ options }: BreadcrumbsProps) => {
  const isMobile = useIsMobile();

  return (
    <MuiBreadcrumbs
      sx={{
        color: 'text.secondary',
        mt: '-10px',
        mb: 3,
        '& .MuiBreadcrumbs-separator': {
          fontSize: 18,
          mx: 0.5,
        },
      }}
      maxItems={isMobile ? 3 : 6}
      separator={<NavigateNextIcon fontSize="inherit" />}
      component="div"
    >
      {options.map(({ title, to }) =>
        to ? (
          <Link
            sx={{
              color: 'primary.main',
              '&:hover': {
                color: 'primary.dark',
              },
            }}
            to={to}
            key={title}
            component={RouterLink}
            underline="none"
          >
            {title}
          </Link>
        ) : (
          <Typography key={title} color="text.secondary" component="div">
            {title}
          </Typography>
        ),
      )}
    </MuiBreadcrumbs>
  );
};
